import type { AssetFamilyContributor } from '~/modules/artist-roster/types';

import { getContributorsByRole } from '../utils';
import { ContributorLink } from './ContributorLink';

interface ContributorLinksProps {
  contributors?: AssetFamilyContributor[];
  type?: 'PRIMARY_ARTIST' | 'FEATURED_ARTIST';
}

export const NO_CONTRIBUTORS_TEXT = '--';

export function ContributorLinks({
  contributors = [],
  type = 'PRIMARY_ARTIST',
}: ContributorLinksProps) {
  const contributorsByRole = getContributorsByRole(contributors, type);

  if (!contributorsByRole.length) {
    return <>{NO_CONTRIBUTORS_TEXT}</>;
  }

  return contributorsByRole.map((contributor, index) => (
    <ContributorLink key={index} index={index} contributor={contributor} />
  ));
}

ContributorLinks.displayName = 'ContributorLinks';
